<template>
  <div v-if="mode==='select'">
    <select
      name="outlet_id"
      class="form-control m-0 p-o"
      v-model="selected"
      @change="save"
    >
      <option  v-for="outlet in options" :value="outlet.id">{{outlet.company.name}} ({{ outlet.name }} )</option>
    </select>
  </div>


  <div v-if="mode==='radio'">
    <div class="row">
      <div class="col">
        <table class="table table-bordered table-hover table-responsive">
          <thead>
          <tr class="bg-tr-color">
            <th> </th>
            <th>Firma</th>
            <th>Avdeling</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="outlet in options.sort((a,b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)">
            <td>
              <input
                type="radio"
                :id="outlet.id"
                :value="outlet.id"
                v-model="selected"
                data-enpassusermodified="yes"
              />
            </td>
            <td><label :for="outlet.id" class="d-block">{{outlet.company.name}}</label></td>
            <td><label :for="outlet.id" class="d-block">{{outlet.name}}</label></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <a
          @click="save"
          role="button"
          href="#"
          class="message-input btn btn-success btn-block"
        >
          Lagre
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CurrentOutletComponent",
  props: {
    'outlets': {
      required: true,
    },
    'current_outlet': {
      required: true,
    },
    'mode': {
      type: String,
      default: 'select'
    }
  },

  data() {
    return {
      selected: parseInt(this.current_outlet),
      options: [],
    }
  },
  emits: ['changed'],
  async mounted() {
    try {
      this.options = JSON.parse(this.outlets)
    } catch (e) {
      this.options = this.outlets;
    }
  },
  methods: {
    save() {
      axios({
        url: `/my/settings/update_outlet`,
        method: 'POST',
        data: {
          outlet_id: this.selected,
        }
      }).then(() => {
        this.$emit('changed');
      }).catch(err => {
        console.log(err);
      });
    },
  },
}
</script>

<style scoped>

</style>
